// src/pages/TrainingPage.jsx
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { trainingService } from '../services/trainingService';

function TrainingPage() {
  const [file, setFile] = React.useState(null);
  const [uploading, setUploading] = React.useState(false);
  const [error, setError] = React.useState('');
  const [result, setResult] = React.useState(null);
  const navigate = useNavigate();

  const onFileChange = (e) => {
    setFile(e.target.files?.[0] || null);
    setError('');
    setResult(null);
  };

  const onUpload = async () => {
    try {
      if (!file) {
        setError('Please select a file');
        return;
      }
      setUploading(true);
      setError('');
      const resp = await trainingService.startManualTrainingUpload(file);
      setResult(resp);
      if (resp?.id) {
        // Navigate directly into the training editor for manual placement
        navigate(`/training/${resp.id}/edit`);
      }
    } catch (err) {
      setError(err?.response?.data?.error || err?.message || 'Upload failed');
    } finally {
      setUploading(false);
    }
  };

  const goToDocument = () => {
    if (result?.id) {
      navigate(`/document/${result.id}`);
    }
  };

  return (
    <div className="min-h-screen bg-gray-900 text-white">
      <div className="max-w-4xl mx-auto px-4 py-10">
        <h1 className="text-2xl font-semibold mb-2">Training</h1>
        <p className="text-gray-300 mb-8">Upload a document for manual field training. This will not be added to your documents list.</p>

        <div className="bg-gray-800 rounded-lg p-6 border border-gray-700">
          <label className="block text-sm font-medium mb-2">Select file (PDF/DOC/DOCX/TXT)</label>
          <input
            type="file"
            accept=".pdf,.doc,.docx,.txt,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,text/plain"
            onChange={onFileChange}
            className="block w-full text-sm text-gray-300 file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold file:bg-blue-600 file:text-white hover:file:bg-blue-500 cursor-pointer"
          />

          <div className="mt-4 flex items-center gap-3">
            <button
              onClick={onUpload}
              disabled={uploading || !file}
              className={`px-4 py-2 rounded-md font-medium ${uploading || !file ? 'bg-gray-600 cursor-not-allowed' : 'bg-blue-600 hover:bg-blue-500'}`}
            >
              {uploading ? 'Uploading…' : 'Upload for Training'}
            </button>

            {result?.id && (
              <button
                onClick={goToDocument}
                className="px-4 py-2 rounded-md font-medium bg-green-600 hover:bg-green-500"
              >
                Open Document
              </button>
            )}
          </div>

          {error && (
            <div className="mt-4 text-red-400 text-sm">{error}</div>
          )}

          {result && (
            <div className="mt-6 text-sm text-gray-300">
              <div className="mb-1">Upload successful.</div>
              <div>Document ID: <span className="text-gray-200 font-mono">{result.id}</span></div>
              <div>Status: {result.status}</div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default TrainingPage;


